import classNames from "classnames";
import React from "react";
import { DeleteCrossIcon } from "@fidget/common/components/icons/deleteCrossIcon/DeleteCrossIcon";
import styles from "./Chip.css";

type Variant = "white" | "base";

export interface Props {
  label: string;
  variant?: Variant;
  onDelete?: () => void;
  icon?: JSX.Element;
  style?: React.CSSProperties;
  className?: string;
}
export const Chip = ({ icon, label, onDelete, style, className, variant = "white" }: Props) => {
  const getVariantClass = () => {
    switch (variant) {
      case "base":
        return styles["variant-base"];
      default:
        return styles["variant-white"];
    }
  };

  return (
    <div className={classNames(styles.container, getVariantClass(), className)} style={style}>
      {icon}
      {label}
      {onDelete && <DeleteCrossIcon onClick={onDelete} />}
    </div>
  );
};
